import React, {Component} from 'react';
const { connect } = require('react-redux');
import {Helmet} from 'react-helmet';

import '../../sass/profile/ProfileIndex.scss';

import HeaderFull from '../../components/profile/HeaderFull';
import ProfileAlbumBlock from '../../components/profile/ProfileAlbumBlock';
import ProfileAmateurFilmsBlock from '../../components/profile/ProfileAmateurFilmsBlock';
import ProfileWallPostsBlock from '../../components/profile/ProfileWallPostsBlock';
import ProfileVirtualGiftsBlock from '../../components/profile/ProfileVirtualGiftsBlock';
import ProfileWishlistBlock from '../../components/profile/ProfileWishlistBlock';
import ProfileGuestbookBlock from '../../components/profile/ProfileGuestbookBlock';
//modals
import ModalBlacklist from '../../components/modals/ModalBlacklist';
import ModalAddBadProfile from '../../components/modals/ModalAddBadProfile';

import {t, dt} from 'l10n';

import {getProfile} from 'reducers/profile';
import {getReturnPath} from 'utils/url';
import {formatLocation, getGenderText} from 'utils/user';
import Loading from 'components/Loading';
import NotFound from 'containers/NotFound';

class ProfileIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalBlacklist: false,
            modalAddBadProfile: false
        };
    }

    static fetchData({dispatch, match}) {
        let {nick} = match.params;
        return dispatch(getProfile(nick));
    }

    componentDidMount() {
        let {dispatch, match, profile} = this.props;
        if (!profile.user || match.params.nick !== profile.user.nick) {
            this.constructor.fetchData({dispatch, match});
        }
    }

    componentDidUpdate(nextProps) {
        if (this.props.match.params.nick !== nextProps.match.params.nick) {
            let {dispatch, match} = this.props;
            this.constructor.fetchData({dispatch, match});
        }
    }

    render() {
        let {modalBlacklist, modalAddBadProfile} = this.state;

        let {match, currentUser, profile} = this.props;
        
        if (!profile || !profile.user) {
            return <Loading centered/>;
        }

        if (profile.user._notFound) {
            return <NotFound {...this.props}/>
        }

        let {
            user,
            followedByMe,
            blacklistedByMe,
            blacklistedMe,
            denounced,
            online,
            stats,
            certifiedMemberPhotos,
            memberPhotos,
            amateurFilms,
            wallMaterials,
            virtualGifts,
            wishlist,
            guestbookMessages
        } = profile;

        let sectionNumber = 0;

        return (
            <div id="wrapper">
                {user &&
                    <Helmet>
                        <title>{dt('meta', '%1, %2, %3, voyeur or exhibitionist on BobTV adult webcam chat', user.nick, formatLocation(user), getGenderText(user))}</title>
                        {user.about ? <meta name="description" content={user.about.replace(/(<([^>]+)>)/ig,"").replace(/[\r\n]+/g," ")}/>
                            : <meta name="description" content={dt('meta', 'Member on adult video chat Bob TV.')}/>
                        }
                    </Helmet>
                }

                <ModalBlacklist
                    show={modalBlacklist}
                    closeFn={() => this.setState({modalBlacklist: false})}
                    blacklistedByMe={blacklistedByMe}
                    user={user}
                />
                <ModalAddBadProfile
                    show={modalAddBadProfile}
                    closeFn={() => this.setState({modalAddBadProfile: false})}
                    user={user}
                />
                <HeaderFull
                    user={user}
                    certifiedMemberPhotos={certifiedMemberPhotos}
                    online={online} stats={stats}
                    match={match}
                    currentUser={currentUser}
                    showModalBlacklist={() => this.setState({modalBlacklist: true})}
                    showModalAddBadProfile={() => this.setState({modalAddBadProfile: true})}
                    followedByMe={followedByMe}
                    denounced={denounced}
                    blacklistedByMe={blacklistedByMe}
                />
                <div className={"profile"}>
                    <ProfileAlbumBlock memberPhotos={memberPhotos} match={match} sectionNumber={sectionNumber++}/>
                    {amateurFilms.list.length ? <ProfileAmateurFilmsBlock amateurFilms={amateurFilms} match={match} sectionNumber={sectionNumber++}/> : ""}
                    {wallMaterials.list.length ? <ProfileWallPostsBlock wallMaterials={wallMaterials} match={match} sectionNumber={sectionNumber++}/> : ""}
                    <ProfileVirtualGiftsBlock virtualGifts={virtualGifts} user={user} match={match} sectionNumber={sectionNumber++}/>
                    {wishlist.list.length ? <ProfileWishlistBlock wishlist={wishlist} user={user} sectionNumber={sectionNumber++}/> : ""}
                    <ProfileGuestbookBlock guestbookMessages={guestbookMessages} currentUser={currentUser} returnPath={getReturnPath({match})} user={user} blacklistedMe={blacklistedMe} match={match} sectionNumber={sectionNumber++}/>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        profile: state.profile
    }),
    null
)(ProfileIndex)


// WEBPACK FOOTER //
// ./src/containers/profile/ProfileIndex.js